export const formatCurrency = (amount, moneda) => {
  const symbol = moneda === 'USD' ? '$' : 'S/';
  const num = typeof amount === 'number' ? amount : Number(amount) || 0;
  return `${symbol} ${num.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatCurrencyShort = (amount, moneda) => {
  const symbol = moneda === 'USD' ? '$' : 'S/';
  const num = typeof amount === 'number' ? amount : Number(amount) || 0;
  return `${symbol} ${(num / 1000).toFixed(0)}K`;
};

export const getCurrencySymbol = (moneda) => (moneda === 'USD' ? '$' : 'S/');
